import CommonStore from "../common_store";
import {action, makeObservable, observable, runInAction} from "mobx";
import api from "../../../api";
import dayjs from "dayjs";
import axios from "axios";
import {message, Modal, UploadFile} from "antd";

class LanguageManageStore {
    @observable contractChain: UploadFile[] = []; //合同链
    @observable sendAudit: boolean = false;
    @observable accountSceneList: any = []; //场景列表
    commonStore?: CommonStore;

    constructor(baseStore?: CommonStore) {
        this.commonStore = baseStore;
        makeObservable(this);
    }

    @observable searchForm: any = {};
    @observable tableData: any = {};
    //表格加载状态
    @observable tableLoad: boolean = true;
    //分页信息
    @observable pageData: IPageData = {
        page: 0,
        size: 10,
        changePage: (page: number, size: number) => {
            runInAction(() => {
                this.pageData.page = page - 1;
                this.pageData.size = size;
                this.pageData = {...this.pageData};
            });
            this.getLanguagePage();
        },
    };

    @observable modalLoading: boolean = false;

//查看详情
    @observable detailData: any = {};
    @observable detailModalLoading: boolean = false;
    @observable detailModal: any = {
        detail: false,
        updateModalType: (type: "detail") => {
        },
        get isOpen(): boolean {
            return this.detail;
        },
        open: (type: "detail", data: any) => {
            if (type === "detail") {
                this.detailModal.detail = true;
                this.detailModalLoading = true;
                this.toDetail(data);
            }
        },
        close: () => {
            runInAction(() => {
                this.detailModal.detail = false;
                this.detailModalLoading = false;
                this.detailData = {};
            });
        },
    };

    //编辑框控制字段
    @observable languageData: any = {};
    @observable addOrUpdateModal: IModal = {
        add: false,
        update: false,
        updateModalType: (type: "add" | "update") => {
        },
        get isOpen(): boolean {
            return this.add || this.update;
        },
        open: (type: "add" | "update", data: any) => {
            if (type === "add") {
                runInAction(() => {
                    this.languageData = {};
                    this.addOrUpdateModal.add = true;
                    this.addOrUpdateModal.update = false;
                });
            } else if (type === "update") {
                runInAction(() => {
                    this.addOrUpdateModal.add = false;
                    this.addOrUpdateModal.update = true;
                    this.languageData = {...data};
                    this.setFormData(data)
                });
            }
        },
        close: () => {
            runInAction(() => {
                this.addOrUpdateModal.add = false;
                this.addOrUpdateModal.update = false;
                this.languageData = {};
                this.contractChain=[]
            });
        },
    };

    setLanguageData(obj: any) {
        runInAction(() => {
            this.languageData = obj;
        });
    }

    setSendAudit(falg: boolean) {
        runInAction(() => {
            this.sendAudit = falg;
        });
    }
    setSearchForm(obj: any) {
        runInAction(() => {
            this.searchForm = obj;
        });
    }

    //重置分页
    resetPage() {
        runInAction(() => {
            this.pageData.page = 0;
        });
    }

    @action
    setpdfList(obj: any, name: string) {
        runInAction(() => {
            this[name as keyof typeof this] = obj;
        });
        // console.log(JSON.parse(JSON.stringify(this.contractChain)))
    }
    //找所有场景
    @action
    getSceneList() {
        api.scriptLanguageApi
            .sceneList()
            .then((res: any) => {
                runInAction(() => {
                    this.accountSceneList =[...res.data] ;
                });
            })
            .catch((e: any) => {});
    }

    //获取临时上传地址
    @action
    async temporaryUpload(file: any, name: string) {
        // console.log(file,name)
        await api.scriptLanguageApi
            .fileUpload({fileName: file.name})
            .then(async (res: any) => {
                file.objectName = res.data.objectName;
                await this.uploadFile(file, res.data.urlPath);
                this.setpdfList(
                    [...(this[name as keyof typeof this] as any), {name:file.name,objectName:file.objectName}],
                    name
                );
            })
            .catch((err: any) => {
                this.languageData.contractChain.pop()
            });
    }

    //上传到临时地址
    uploadFile(file: any, url: any) {
        axios
            .put(url, file, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                withCredentials: false,
            })
            .then((response) => {
            })
            .catch((err) => {
            });
    }

    //上传文件回显
    setFormData(res: any) {
        // console.log(JSON.parse(JSON.stringify(res)))
        this.languageData.contractChain = res?.contractChain.map((item: any, index: number) => ({
            objectName: item.objectName,
            name: item.contractName
        }))
        this.contractChain = this.languageData.contractChain
        this.languageData.expireDate=dayjs(res.expireDate);
        this.setLanguageData({...this.languageData})
    }

    toDelete(id: string) {
        return new Promise((resolve, reject) => {
            Modal.confirm({
                centered: true,
                title: "确认删除",
                content: "您确定要删除该话术吗？",
                okText: "确认",
                cancelText: "取消",
                onOk: () => {
                    this.deleteLanguage(id);
                    return resolve(true);
                },
                onCancel: () => {
                    return false;
                },
            });
        });
    }

    @action
    deleteLanguage(id: string) {
        api.scriptLanguageApi
            .languageDelete(id)
            .then((res: any) => {
                message.success("删除成功");
                this.resetPage();
                this.getLanguagePage();
            })
            .catch((e: any) => {
            });
    }
    @action
    updateLanguage(data: any) {
        data.contractChain=this.contractChain.map((item:any)=>{
            item.contractName=item.name
            return item
        })
        data.expireDate=dayjs(data.expireDate).format("YYYY-MM-DD");
        api.scriptLanguageApi
            .languageUpdate(data)
            .then((res: any) => {
                message.success("编辑成功");
                this.addOrUpdateModal.close()
                this.getLanguagePage();
            })
            .catch((e: any) => {
            });
    }
    @action
    addLanguage(data: any) {
        data.contractChain=this.contractChain.map((item:any)=>{
            item.contractName=item.name
            return item
        })
        data.expireDate=dayjs(data.expireDate).format("YYYY-MM-DD");
        api.scriptLanguageApi
            .languageAdd(data)
            .then((res: any) => {
                message.success("保存成功");
                this.addOrUpdateModal.close()
                this.getLanguagePage();
            })
            .catch((e: any) => {
            });
    }

    //分页查询
    @action
    getLanguagePage() {
        this.commonStore?.getPagePermission("talk_script_management");
        if (this.searchForm.expireTime && this.searchForm.expireTime.length > 0) {
            this.searchForm.expireEndDate = dayjs(this.searchForm.expireTime[1]).format("YYYY-MM-DD");
            this.searchForm.expireBeginDate = dayjs(this.searchForm.expireTime[0]).format("YYYY-MM-DD");
        }
        if (this.searchForm.auditLaunchDate && this.searchForm.auditLaunchDate.length > 0) {
            this.searchForm.auditLaunchEndDate = dayjs(this.searchForm.auditLaunchDate[1]).format("YYYY-MM-DD HH:mm:ss");
            this.searchForm.auditLaunchBeginDate = dayjs(this.searchForm.auditLaunchDate[0]).format("YYYY-MM-DD HH:mm:ss");
        }
        runInAction(() => {
            this.tableData = {};
            this.tableLoad = true;
        });
        const data = {...this.searchForm};
        data.size = this.pageData.size;
        data.page = this.pageData.page;
        api.scriptLanguageApi
            .languagePage(data)
            .then((res: any) => {
                if (res.code == 200) {
                    runInAction(() => {
                        this.tableData = res.data;
                        this.tableData = {...this.tableData};
                        this.tableLoad = false;
                    });
                }
            })
            .catch((e: any) => {
                runInAction(() => {
                    this.tableLoad = false;
                });
            });
    }

    //查看详情
    @action
    toDetail(data: any) {
      api.scriptLanguageApi
          .languageDetail(data.id)
          .then((res: any) => {
            runInAction(() => {
              this.detailData = {...res.data};
              this.detailModalLoading = false;
            });
          })
          .catch((e: any) => {
            this.detailModal.close();
          });
    }

    //下载
    @action
    exportFile(objectName: string) {
        api.scriptLanguageApi
            .fileDownload(objectName)
            .then(async (res: any) => {
                window.open(res.data, '_blank')
            })
            .catch((err: any) => {
            });
    }


}

export default LanguageManageStore;
